import styles from "@styles/containers/cdp/customer-fidelity.module.scss";
import dayjs from "dayjs";

import classNames from "classnames/bind";
import { useEffect, useState } from "react";
import { If } from "shared/components/control-statements";
import { Currency } from "shared/utils/Currency";
const css = classNames.bind(styles);

const CashbackEvent = ({ event, programByPoint }) => {
  const [collapsed, setCollapsed] = useState(false);

  const getUserOrigin = (event) => {
    const actionName =
      event.operationId === "CREDIT" ? "Adicionado" : "Removido";
    return `${actionName} por ${event.origin.user.username}`;
  };

  const getType = (event) => {
    const types = {
      CREDIT: "Entrada",
      DEBIT: "Saída",
      EXPIRATION: "Expiração",
      REFUND: "Estorno",
      MANUAL:
        event.operationId === "CREDIT" ? "Adição manual" : "Remoção manual",
    };

    if (types[event.type]) return types[event.type];
  };

  useEffect(() => {
    setCollapsed(false);
  }, [event]);

  return (
    <div className={css({ event: true, collapsed: collapsed })}>
      <div className={styles.header}>
        <div className="d-flex align-center">
          <p className={styles.date}>
            {dayjs(event.createdAt).format("DD/MM/YY")}
          </p>
          <span className={styles.dot} />
          <p className={styles.type}>{getType(event)}</p>
        </div>
        <If cond={event.value}>
          <p
            className={css({
              value: true,
              positive: event.operationId === "CREDIT",
              negative: event.operationId === "DEBIT",
            })}
          >
            {event.operationId === "CREDIT" ? "+ " : "- "}
            {programByPoint
              ? `${event.value} pontos`
              : Currency.formatCurrency(event.value)}
          </p>
        </If>
      </div>

      <div className={css({ details: true, show: collapsed })}>
        {event.origin.brand && <p>Marca: {event.origin.brand.name}</p>}

        {event.origin.unit && <p>Unidade: {event.origin.unit.name}</p>}

        {event.expirationDate && (
          <p>Expiração: {dayjs(event.expirationDate).format("DD/MM/YY")}</p>
        )}

        {event.origin.user && <p>Origem: {getUserOrigin(event)}</p>}

        {event.origin.order && (
          <p>Origem: {event.origin?.order?.deliveryType}</p>
        )}
      </div>

      <If cond={event.type !== "EXPIRATION"}>
        <div className={styles.seeDetails}>
          <div
            className={styles.collapseDetails}
            onClick={() => setCollapsed(!collapsed)}
          >
            <p>{collapsed ? "Ocultar detalhes" : "Ver detalhes"}</p>
            {collapsed ? (
              <i className="fas fa-chevron-up" />
            ) : (
              <i className="fas fa-chevron-down" />
            )}
          </div>
        </div>
      </If>
    </div>
  );
};

export default CashbackEvent;
